import pako from 'pako';

import type { MyDB } from './openIDB';

export type LandmarkRecord = MyDB['landmarks']['value'];
type ChunkPayload = {
  formDataId: number;
  seq: number;
  final: false;
  clientRunId?: string;
  samples: Array<{
    ok: true;
    mediaIndex: number;
    landmarks: LandmarkRecord['landmarks'];
    timestamp: number;
  }>;
};

export const toPositiveInt = (value: unknown, fallback: number): number => {
  const parsed = typeof value === 'string' ? Number.parseInt(value, 10) : Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
};

export const DEFAULT_MAX_PAYLOAD_BYTES = 1_500_000;

export function computeMaxPayloadBytes(raw: unknown): number {
  return toPositiveInt(raw, DEFAULT_MAX_PAYLOAD_BYTES);
}

export function buildChunkPayload(
  formDataId: number,
  seq: number,
  records: LandmarkRecord[],
  clientRunId?: string | null,
): ChunkPayload {
  const payload: ChunkPayload = {
    formDataId,
    seq,
    final: false,
    samples: records.map(({ mediaIndex, landmarks, timestamp }) => ({
      ok: true,
      mediaIndex,
      landmarks,
      timestamp,
    })),
  };
  if (clientRunId) payload.clientRunId = clientRunId;
  return payload;
}

export function gzipPayload(payload: unknown): Uint8Array {
  return pako.gzip(JSON.stringify(payload));
}

export function createCompressedChunk(
  formDataId: number,
  seq: number,
  records: LandmarkRecord[],
  clientRunId?: string | null,
): { payload: ChunkPayload; compressed: Uint8Array } {
  const payload = buildChunkPayload(formDataId, seq, records, clientRunId);
  const compressed = gzipPayload(payload);
  return { payload, compressed };
}
